import { compose, withHandlers, withState } from 'recompose'

const enhance = compose(
  withState('expanded', 'setExpanded', false),
  withHandlers({
    handleRollUpView: props => () => props.setExpanded(!props.expanded),
  }),
)

export default enhance
